import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';
import { asArray } from '../payloadGuards';

export const fetchMetrics = createAsyncThunk(
    'metrics/fetchMetrics',
    async () => {
        try {
            const response = await api.get('/metrics');
            return response.data;
        } catch (error) {

            throw new Error(error.message);
        }
    }
);


const initialState = {
    metrics: [],
    status: 'idle',
    error: null,
};

const metricSlice = createSlice({
    name: 'metrics',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchMetrics.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(fetchMetrics.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.metrics = asArray(action.payload);
        });
        builder.addCase(fetchMetrics.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        });
    },
});

export default metricSlice.reducer;
